import React, { useState } from "react";
import newObjectData, { CMRItem } from "data/newObject";
import AddEditObjectItemComponent from "./AddEditObjectItemComponent";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
import { useTheme } from "@mui/material/styles";
import useDrag from "./UseDrag";
import AddEditObjectRoomSizeComponent from "./AddEditObjectRoomSizeComponent";
import { LeftArrow, RightArrow } from "./HorizontalScrollingArrows";
import AddAccessPointComponent from "./AddAccessPointComponent";

type ComponentProps = {
    device: string;
};

interface TabPanelProps {
    children?: React.ReactNode;
    dir?: string;
    index: number;
    value: number;
}
type scrollVisibilityApiType = React.ContextType<typeof VisibilityContext>;

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`addEditObject-${index}`}
            aria-labelledby={`addEditObject-${index}`}
            {...other}
        >
            {value === index && (
                <div>
                    <h2>{children}</h2>
                </div>
            )}
        </div>
    );
}

function onWheel(apiObj: scrollVisibilityApiType, ev: React.WheelEvent): void {
    const isThouchpad = Math.abs(ev.deltaX) !== 0 || Math.abs(ev.deltaY) < 15;

    if (isThouchpad) {
        ev.stopPropagation();
        return;
    }

    if (ev.deltaY < 0) {
        apiObj.scrollNext();
    } else if (ev.deltaY > 0) {
        apiObj.scrollPrev();
    }
}

const AddEditObjectComponent = ({ device }: ComponentProps): JSX.Element => {
    const [value, setValue] = useState(0);
    const { dragStart, dragStop, dragMove } = useDrag();
    const theme = useTheme();

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const renderItem = (item: CMRItem) => {
        return (
            <AddEditObjectItemComponent
                key={item.id}
                device={device}
                itemId={item.id}
                item={item}
            />
        );
    };

    const handleDrag =
        ({ scrollContainer }: scrollVisibilityApiType) =>
        (ev: React.MouseEvent) =>
            dragMove(ev, (posDiff) => {
                if (scrollContainer.current) {
                    scrollContainer.current.scrollLeft += posDiff;
                }
            });

    return (
        <>
            <section className="addEditObjectContainer desktop onlyDesktop">
                <div className="addEditObject">{newObjectData.map((item) => renderItem(item))}</div>
                <AddEditObjectRoomSizeComponent />
                <AddAccessPointComponent />
            </section>

            <section className="addEditObjectContainer mobile">
                <Tabs
                    className="newObjectTabs"
                    variant="fullWidth"
                    value={value}
                    onChange={handleChange}
                    textColor="secondary"
                    indicatorColor="secondary"
                    aria-label="new or edit object"
                >
                    <Tab value={0} label="Add new" />
                    <Tab value={1} label="Room size" />
                    <Tab value={2} label="Access Points" />
                </Tabs>
                <TabPanel value={value} index={0} dir={theme.direction}>
                    <div className="addEditObject">
                        <ScrollMenu
                            transitionBehavior="smooth"
                            LeftArrow={LeftArrow}
                            RightArrow={RightArrow}
                            onWheel={onWheel}
                            onMouseDown={() => dragStart}
                            onMouseUp={() => dragStop}
                            onMouseMove={handleDrag}
                        >
                            {newObjectData.map((item) => renderItem(item))}
                        </ScrollMenu>
                    </div>
                </TabPanel>
                <TabPanel value={value} index={1} dir={theme.direction}>
                    <AddEditObjectRoomSizeComponent />
                </TabPanel>
                <TabPanel value={value} index={2} dir={theme.direction}>
                    <AddAccessPointComponent />
                </TabPanel>
            </section>
        </>
    );
};

export default AddEditObjectComponent;
